import { CdkService } from 'api-new/generated';
import { QueryError } from 'features/shared/model';
import { useQuery } from 'react-query';

export const useVehicleRelationsQuery = (vehicleId: string) =>
  useQuery<Awaited<ReturnType<typeof CdkService.getCdkVehiclesVehicleRelations>>, QueryError>(
    ['vehicleRelations', vehicleId],
    () => CdkService.getCdkVehiclesVehicleRelations(vehicleId),
    {
      enabled: !!vehicleId
    }
  );
